@if (startLoader) {
<div class="loader-overlay">
  <div class="backdrop"></div>
  <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false" [displayNotification]="showDREMsg" [notifMsg]="DREMsg"
                               (onCancelClick)="clear()">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div [formGroup]="form400" class="ap-form-field-my-wrapper">
    <dst-template-header [parentFormGroup]="form400" (formOptionChanged)="onFormOptionChanged($event)"
                         (consolGroupChanged)="OnConsolGroupChanged($event)">
    </dst-template-header>

    <!-- ======================== SECTION: Reporting Entity ======================== -->
    <div id="part0" class="section-content" style="margin-top: 15px;">
      <dst-template-leid-selector class="required-field" [label]="'Please specify the LEID of the reporting entity'"
        [labelId]="'1'" (onSelectedLEChanged)="onReportingEntityChanged($event)">
      </dst-template-leid-selector>

      <div class="entity-details">
        <span class="ent-label">Entity Name:</span>
        <span class="template-color-blue">{{!reportingEntity ? '' : reportingEntity.ENTITY}}</span>
      </div>
      <div class="entity-details">
        <span class="ent-label">Federal ID:</span>
        <span class="template-color-blue">{{!reportingEntity ? '' : (reportingEntity.EIN ? reportingEntity.EIN : 'N/A')}}</span>
      </div>
    </div>

    <!-- ======================== SECTION: FDE/FB Information ======================== -->
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;FDE or FB Information</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div formGroupName="fdeInfo" class="section-content ap-form-field-my-wrapper">
      <dst-template-leid-selector class="required-field" [label]="'Please specify the DRC/Separate Unit LEID'" [labelId]="'100'"
                                  (onSelectedLEChanged)="onFDEEntityChanged($event)">
      </dst-template-leid-selector>

      <div class="entity-details">
        <span class="ed-label">Name of FDE or FB:</span>
        <span class="template-color-blue">{{ FDEOrFBName }}</span>
      </div>

      <div class="entity-details">
        <span class="ed-label">Address Line 1:</span>
        <span class="template-color-blue">{{ FDEOrFBAddressLine1 }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">Address Line 2:</span>
        <span class="template-color-blue">{{ FDEOrFBAddressLine2 }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">City / Town:</span>
        <span class="template-color-blue">{{ FDEOrFBCity }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">Country:</span>
        <span class="template-color-blue">{{ FDEOrFBCountryCd }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">Postal Code:</span>
        <span class="template-color-blue">{{ FDEOrFBPostalCd }}</span>
      </div>

      <br/>
      <div class="entity-details">
        <span class="ed-label">Identifying number (EIN):</span>
        <span class="template-color-blue">{{ !fdeEntity ? '' : (FDEEIN ? FDEEIN : 'N/A') }}</span>
      </div>
      @if (!FDEEIN && fdeEntity) {
<div class="entity-details">
        <span class="ed-label">Reference ID number:</span>
        <span class="template-color-blue">{{ ForeignEntityRefIdNum }}</span>
      </div>
}

      <br/>
      <div class="entity-details">
        <span class="ed-label">FDE or FB's Annual Accounting Period - Beginning:</span>
        @if (nameChangeChecked) {
<app-date-picker-with-clear
         
          [minDate]="beginDate"
          [maxDate]="endDate"
          [datePickerClass]="'required-field'"
          [required]="true"
          (dateChange)="dateChange($event, 1)"
          (datePickerClick)="onDPOpen()"
          (clearClick)="clearDate(1)"
          [(ngModel)]="AnnualAcctPeriodBeginDt" [ngModelOptions]="{standalone: true}">
        </app-date-picker-with-clear>
}
      </div>
      <div class="entity-details">
        <span class="ed-label">FDE or FB's Annual Accounting Period - Ending:</span>
        @if (nameChangeChecked) {
<app-date-picker-with-clear
         
          [minDate]="beginDate"
          [maxDate]="endDate"
          [datePickerClass]="'required-field'"
          [required]="true"
          (dateChange)="dateChange($event, 2)"
          (datePickerClick)="onDPOpen()"
          (clearClick)="clearDate(2)"
          [(ngModel)]="AnnualAcctPeriodEndDt" [ngModelOptions]="{standalone: true}">
        </app-date-picker-with-clear>
}
      </div>

      <div class="entity-details">
        <span class="ed-label">FDE or FB's Type:</span>
        <div class="d-inline-block">
        <ap-dropdown class="required-field-dropdown" [list]="FDEFBTypeOptions" [selectType]="'single'"
                     [title]="'** Please select FDE/FB Type **'" [inputAriaLabel]="'** Please select FDE/FB Type **'"
                     [(ngModel)]="selectedFDEFBTypeItem" [ngModelOptions]="{standalone: true}"
                     [hideTitleOnInput]="true"
                     [required]="true"
                     (onSelect)="onFDEFBTypeChange($event)">
          @for (item of FDEFBTypeOptions; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
            [ariaLabel]="setAriaLabel(item, '** Please select FDE/FB Type **')"
            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
        </ap-dropdown>
      </div>
      </div>
      <br/>
      <div class="entity-details">
        <span class="ed-label">FDE or FB's Return Status:</span>
        <div class="d-inline-block">
        <ap-dropdown [list]="ReturnStatusOptions" [selectType]="'single'"
                     [title]="'** Please select Return Status **'" [inputAriaLabel]="'** Please select Return Status **'"
                     [(ngModel)]="selectedReturnStatusItem" [ngModelOptions]="{standalone: true}"
                     [hideTitleOnInput]="true"
                     (onSelect)="onReturnStatusChange($event)">
          @for (item of ReturnStatusOptions; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
            [ariaLabel]="setAriaLabel(item, '** Please select Return Status **')"
            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
        </ap-dropdown>
        </div>
      </div>
    </div>

    <!-- ======================== SECTION: Tax Owner Information ======================== -->
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;U.S. Tax Owner Information</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div formGroupName="taxOwnerInfo" class="section-content ap-form-field-my-wrapper">
      <dst-template-leid-selector #taxOwnerLeidComp class="required-field" [label]="'Please specify the DRC/Separate Unit U.S. Tax Owner LEID'" [labelId]="'200'"
                                  (onSelectedLEChanged)="onTaxOwnerEntityChanged($event)">
      </dst-template-leid-selector>

      <div class="entity-details">
        <span class="ed-label">Name of Tax Owner:</span>
        <span class="template-color-blue">{{ TaxOwnerName }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">Address Line 1:</span>
        <span class="template-color-blue">{{ TaxOwnerAddressLine1 }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">Address Line 2:</span>
        <span class="template-color-blue">{{ TaxOwnerAddressLine2 }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">City:</span>
        <span class="template-color-blue">{{ TaxOwnerCity }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">State:</span>
        <span class="template-color-blue">{{ stateNameForTaxOwner }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">ZIP Code:</span>
        <span class="template-color-blue">{{ TaxOwnerZIP }}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">Identifying number (EIN):</span>
        <span class="template-color-blue">{{ !taxOwnerEntity ? '' : (TaxOwnerEIN ? TaxOwnerEIN : 'N/A') }}</span>
      </div>
    </div>

    <!-- ======================== SECTION: Schedule G - Dual Consolidated Loss ======================== -->
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Schedule G &nbsp;&nbsp;</strong>
          <strong>Dual Consolidated Loss</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="section-content ap-form-field-my-wrapper">

      <!-- Combined separate unit question (line number omitted; aligns with 10b text column) -->
      <div class="d-flex align-items-center mb-3">
        <div class="col-md-1"></div>
        <div class="col-md-7">
          Is the FB or the interest in the FDE part of a combined separate unit under Regulations section 1.1503(d)-1(b)(4)(ii)? [The response will determine Lines 10a and 11a on Form 8858, not displayed here]
        </div>
        <div class="col-md-4 radio-group-row">
          <ap-radio-group [ariaLabel]="'Is the FB or the interest in the FDE part of a combined separate unit under Regulations section 1.1503(d)-1(b)(4)(ii)?'" [name]="'radio-sep-unit'">
          <ap-radio [name]="'radio-sep-unit'" [(ngModel)]="SeparateUnitDefinedInRegInd" [value]="$any(true)"
                    [ngModelOptions]="{standalone: true}" (onChange)="checkSeparateUnitInd(true)" [styleClass]="'a-mx-10'">
            <span>Yes</span>
          </ap-radio>
          <ap-radio [name]="'radio-sep-unit'" [(ngModel)]="SeparateUnitDefinedInRegInd" [value]="$any(false)"
                    [ngModelOptions]="{standalone: true}" (onChange)="checkSeparateUnitInd(false)" [styleClass]="'a-mx-10'">
            <span>No</span>
          </ap-radio>
          </ap-radio-group>
          @if (SeparateUnitDefinedInRegInd !== undefined) {
            <ap-button [btnType]="'text'"
              [compact]="true"
              (onClick)="clearSeparateUnitInd()" class="clear-radio-btn" [title]="'Clear'"
              [attr.aria-label]="'Clear combined separate unit answer'">
              <span class="Appkit4-icon icon-close-outline"></span>
            </ap-button>
          }
        </div>
      </div>

      <!-- Line 10b: Net Income (Loss) - shown only if 10a = No -->
      <div [hidden]="!show10aNoSection">
        <div class="d-flex align-items-center mb-3">
          <div class="col-md-1"><strong>10b.</strong></div>
          <div class="col-md-7">
            Net Income (Loss) attributable to DRC/Separate Unit from a DCL Perspective
          </div>
          <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
            <span class="currency-prefix">$</span>
            <ap-field [title]="''" [fieldId]="'sched-g-1'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="NetIncomeLossAmt" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="Sched-g-1" />
            </ap-field>
          </div>
        </div>
      </div>

      <!-- Line 11b: Amount of Dual Consolidated Income (Loss) for the Combined Separate Unit - shown only if 10a = Yes -->
      <div [hidden]="!show10aYesSection">
        <div class="d-flex align-items-center mb-3">
          <div class="col-md-1"><strong>11b.</strong></div>
          <div class="col-md-7">
            Amount of Dual Consolidated Income (Loss) for the Combined Separate Unit
          </div>
          <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
            <span class="currency-prefix">$</span>
            <ap-field [title]="''" [fieldId]="'sched-g-2'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="DualConsolidatedLossAmt" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="Sched-g-2" />
            </ap-field>
          </div>
        </div>
      </div>

      <!-- Line 11c: Editable textbox - shown when 10a = Yes -->
      <div [hidden]="!show10aYesSection">
        <div class="d-flex align-items-center mb-3">
          <div class="col-md-1"><strong>11c.</strong></div>
          <div class="col-md-7">
            Net Income (Loss) attributed to the individual FB or the individual interest in the FDE
          </div>
          <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
            <span class="currency-prefix">$</span>
            <ap-field [title]="''" [fieldId]="'sched-g-11c'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="SepCombSepDualCnsldtLossAmt" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="Sched-g-11c" />
            </ap-field>
          </div>
        </div>
      </div>

      <!-- Line 12a: DualCnsldtLossTaxableIncomeInd (always visible) -->
      <div class="d-flex mb-3">
        <div class="col-md-1"><strong>12a.</strong></div>
        <div class="col-md-7">
          Was any portion of the dual consolidated loss taken into account in computing U.S. taxable income for the year?
        </div>
        <div class="col-md-4">
          <ap-radio-group [ariaLabel]="'Was any portion of the dual consolidated loss taken into account in computing U.S. taxable income for the year?'" [name]="'radio-dcl-taxable'">
          <ap-radio [name]="'radio-dcl-taxable'" [(ngModel)]="DualCnsldtLossTaxableIncomeInd" [value]="$any(true)"
                    [ngModelOptions]="{standalone: true}" (onChange)="checkDualCnsldtLossTaxableIncomeInd(true)" [styleClass]="'a-mx-10'">
            <span>Yes</span>
          </ap-radio>
          &nbsp;&nbsp;
          <ap-radio [name]="'radio-dcl-taxable'" [(ngModel)]="DualCnsldtLossTaxableIncomeInd" [value]="$any(false)"
                    [ngModelOptions]="{standalone: true}" (onChange)="checkDualCnsldtLossTaxableIncomeInd(false)" [styleClass]="'a-mx-10'">
            <span>No</span>
          </ap-radio>
          </ap-radio-group>
        </div>
      </div>

      <!-- Line 12b: PermittedDomDualCnsldtLossInd (visible if 12a !== false) -->
      <div [hidden]="!show12b">
        <div class="d-flex mb-3">
          <div class="col-md-1"><strong>12b.</strong></div>
          <div class="col-md-7">
            Was the DCL a permitted domestic use of the dual consolidated loss under Regulations section 1.1503(d)-6?
          </div>
          <div class="col-md-4 radio-group-row">
            <ap-radio-group [ariaLabel]="'Was the DCL a permitted domestic use of the dual consolidated loss under Regulations section 1.1503(d)-6?'" [name]="'radio-permitted-dom'">
            <ap-radio [name]="'radio-permitted-dom'" [(ngModel)]="PermittedDomDualCnsldtLossInd" [value]="$any(true)"
                      [ngModelOptions]="{standalone: true}" (onChange)="checkPermittedDomInd(true)" [styleClass]="'a-mx-10'">
              <span>Yes</span>
            </ap-radio>
            <ap-radio [name]="'radio-permitted-dom'" [(ngModel)]="PermittedDomDualCnsldtLossInd" [value]="$any(false)"
                      [ngModelOptions]="{standalone: true}" (onChange)="checkPermittedDomInd(false)" [styleClass]="'a-mx-10'">
              <span>No</span>
            </ap-radio>
            </ap-radio-group>
            @if (PermittedDomDualCnsldtLossInd !== undefined) {
<ap-button [btnType]="'text'"
              [compact]="true"
              (onClick)="clearPermittedDomInd()" class="clear-radio-btn" [title]="'Clear'">
              <span class="Appkit4-icon icon-close-outline"></span>
            </ap-button>
}
          </div>
        </div>
      </div>

      <!-- Line 12c: PrmtDomDualCnsldtLossDcmntnInd (visible if 12a !== false AND 12b is Yes) -->
      <div [hidden]="!show12c">
        <div class="d-flex mb-3">
          <div class="col-md-1"><strong>12c.</strong></div>
          <div class="col-md-7">
            Is a Domestic Use Election or other required documentation pursuant to Regulations section 1.1503(d)-6 attached to the return?
          </div>
          <div class="col-md-4 radio-group-row">
            <ap-radio-group [ariaLabel]="'Is a Domestic Use Election or other required documentation pursuant to Regulations section 1.1503(d)-6 attached to the return?'" [name]="'radio-prmt-dcmntn'">
            <ap-radio [name]="'radio-prmt-dcmntn'" [(ngModel)]="PrmtDomDualCnsldtLossDcmntnInd" [value]="$any(true)"
                      [ngModelOptions]="{standalone: true}" (onChange)="checkPrmtDomDcmntnInd(true)" [styleClass]="'a-mx-10'">
              <span>Yes</span>
            </ap-radio>
            <ap-radio [name]="'radio-prmt-dcmntn'" [(ngModel)]="PrmtDomDualCnsldtLossDcmntnInd" [value]="$any(false)"
                      [ngModelOptions]="{standalone: true}" (onChange)="checkPrmtDomDcmntnInd(false)" [styleClass]="'a-mx-10'">
              <span>No</span>
            </ap-radio>
            </ap-radio-group>
            @if (PrmtDomDualCnsldtLossDcmntnInd !== undefined) {
<ap-button [btnType]="'text'"
              [compact]="true"
              (onClick)="clearPrmtDomDcmntnInd()" class="clear-radio-btn" [title]="'Clear'">
              <span class="Appkit4-icon icon-close-outline"></span>
            </ap-button>
}
          </div>
        </div>
      </div>

      <!-- Line 12d: CmptDualCnsldtLossTxblIncmInd (visible if 12b is No, or 12b is Yes and 12c is not Yes) -->
      <div [hidden]="!show12d">
        <div class="d-flex mb-3">
          <div class="col-md-1"><strong>12d.</strong></div>
          <div class="col-md-7">
            If this was not a permitted domestic use, was the dual consolidated loss used to compute consolidated taxable income as provided under Regulations section 1.1503(d)-4?
          </div>
          <div class="col-md-4 radio-group-row">
            <ap-radio-group [ariaLabel]="'If this was not a permitted domestic use, was the dual consolidated loss used to compute consolidated taxable income as provided under Regulations section 1.1503(d)-4?'" [name]="'radio-cmpt-dcl'">
            <ap-radio [name]="'radio-cmpt-dcl'" [(ngModel)]="CmptDualCnsldtLossTxblIncmInd" [value]="$any(true)"
                      [ngModelOptions]="{standalone: true}" (onChange)="checkCmptDualCnsldtInd(true)" [styleClass]="'a-mx-10'">
              <span>Yes</span>
            </ap-radio>
            <ap-radio [name]="'radio-cmpt-dcl'" [(ngModel)]="CmptDualCnsldtLossTxblIncmInd" [value]="$any(false)"
                      [ngModelOptions]="{standalone: true}" (onChange)="checkCmptDualCnsldtInd(false)" [styleClass]="'a-mx-10'">
              <span>No</span>
            </ap-radio>
            </ap-radio-group>
            @if (CmptDualCnsldtLossTxblIncmInd !== undefined) {
<ap-button [btnType]="'text'"
              [compact]="true"
              (onClick)="clearCmptDualCnsldtInd()" class="clear-radio-btn" [title]="'Clear'">
              <span class="Appkit4-icon icon-close-outline"></span>
            </ap-button>
}
          </div>
        </div>
      </div>

      <!-- Line 12e: CumulativeRegisterAmt (always visible) -->
      <div class="d-flex align-items-center mb-3">
        <div class="col-md-1"><strong>12e.</strong></div>
        <div class="col-md-7">
          Enter the separate unit's contribution to the cumulative consolidated taxable income ("cumulative register") as of the beginning of the tax year
        </div>
        <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
          <span class="currency-prefix">$</span>
          <ap-field [title]="''" [fieldId]="'sched-g-4'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="CumulativeRegisterAmt" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="Sched-g-4" />
          </ap-field>
        </div>
      </div>

      <!-- Line 13a: TriggeringEventRecaptureInd (always visible) -->
      <div class="d-flex mb-3">
        <div class="col-md-1"><strong>13a.</strong></div>
        <div class="col-md-7">
          During the tax year, did any triggering event(s) occur under Regulations section 1.1503(d)-6(e) requiring recapture of any dual consolidated loss(es) attributable to the FB or interest in the FDE, individually or as part of a combined separate unit, in any prior tax years?
        </div>
        <div class="col-md-4">
          <ap-radio-group [ariaLabel]="'During the tax year, did any triggering event(s) occur under Regulations section 1.1503(d)-6(e) requiring recapture of any dual consolidated loss(es)?'" [name]="'radio-trigger-event'">
          <ap-radio [name]="'radio-trigger-event'" [(ngModel)]="TriggeringEventRecaptureInd" [value]="$any(true)"
                    [ngModelOptions]="{standalone: true}" (onChange)="checkTriggeringEventInd(true)" [styleClass]="'a-mx-10'">
            <span>Yes</span>
          </ap-radio>
          &nbsp;&nbsp;
          <ap-radio [name]="'radio-trigger-event'" [(ngModel)]="TriggeringEventRecaptureInd" [value]="$any(false)"
                    [ngModelOptions]="{standalone: true}" (onChange)="checkTriggeringEventInd(false)" [styleClass]="'a-mx-10'">
            <span>No</span>
          </ap-radio>
          </ap-radio-group>
        </div>
      </div>

      <!-- Line 13b: TriggeringEventRecaptureAmt - shown if 13a = Yes -->
      <div [hidden]="!showTriggeringRecaptureAmt">
        <div class="d-flex align-items-center mb-3">
          <div class="col-md-1"><strong>13b.</strong></div>
          <div class="col-md-7">
            If yes, enter the total amount of recapture
          </div>
          <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
            <span class="currency-prefix">$</span>
            <ap-field [title]="''" [fieldId]="'sched-g-5'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="TriggeringEventRecaptureAmt" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="Sched-g-5" />
            </ap-field>
          </div>
        </div>
      </div>

      <div class="leid-list d-flex" style="margin-top: 15px;">
        <span>LEIDs: </span>
        <div>
          @if (fdeEntity) {
<span class="template-color-blue">{{ fdeEntity.LEID }}</span>
}
          @if (fdeEntity && taxOwnerEntity) {
<span> / </span>
}
          @if (taxOwnerEntity) {
<span class="template-color-blue">{{ taxOwnerEntity.LEID }}</span>
}
        </div>
      </div>
    </div>
  </div>
</div>
